const style = {
  avatarBox: {
    width: `45px`,
    height: `45px`,
    // background: `#0079ff`,
    borderRadius: `3px`
  },
  avatarSpan: {
    color: `black`,
    fontSize: `14px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Support/style/author.js